// Project descriptions for popups
const projectDescriptions = {
  "Rundoo - Software Engineering Intern": `
Rundoo is a series A startup!

Here's Rundoo's Product:
An online POS and all-in-one management system for niche verticals (paint, hardware, farm/feed, plant nurseries (upcoming)). Rundoo provides the following software: A client web app, a client app, vendor-specific integrations, and an app for the client's customers.

<img src="/images/main.png" alt="Rundoo product diagram" style="max-width: 100%; height: auto; margin: 20px 0;">

I worked on the client/customer side across 2 teams as a SWE intern using Go/TypeScript.

<strong>Report Builder Team:</strong> Backbone of Rundoo's AI system. The main goal of report builder is to dynamically generate any informational report a customer can ask for. Report builder was fully built in ~1.5 months with a team of around 4 people.

There are 3 main methods for using report builder:

1. <strong>Using the UI:</strong> After selecting a base data (such as transactions), users can:
• Select columns they want displayed
• Group by certain rows or columns
• Apply filters
• Apply an aggregation to a column (for example, instead of having the amount of total revenue across all transactions per day it can show the max transaction amount for that day)
• See summary cards at the top which can also apply aggregations to data
• Reorder columns through a drag-and-drop UI
• Click into a specific cell to see a drill down view of how that cell was calculated
• Compare across different date ranges
• Save, export to any format (pdf, excel, etc.)
• Reset the report to a previously saved version

2. Users can go onto the saved report sections which includes commonly accessed reports by all customers (such as inventory by month).

3. Almost all requests to the AI chatbot can be converted into an API request to our report builder system that the LLM then analyzes. For example, "what is my best-selling product last year" can be converted into a sold products report grouped by product id, filtered on a time period of last year, and a max aggregation applied to the "amount" column.

<hr style="border: none; border-top: 1px solid rgba(255,255,255,0.3); margin: 1rem 0 0.4rem 0;" />

<strong>Ledger Team:</strong> Managing any financial records.

My main work on the ledger team:
I built an ACH payment system at Rundoo to let customers pay off their charge balances directly from a bank account. Many Rundoo clients allow customers to make repeated purchases, such as buying supplies weekly, under a running charge, which is settled later through a bill payment. Before this project, most monitored payments were handled through credit cards, which introduced high external processing fees. This project added ACH as a first-class payment method, giving clients a faster, lower-cost alternative while integrating cleanly with existing billing, ledger, and refund flows.

To begin, customers securely add and verify a bank account. On web, the backend creates a Stripe-hosted bank setup session and sends the setup link via email or SMS using SendGrid and Twilio. On mobile, bank verification happens in-session using Stripe's bank-linking flow. In both cases, the verified bank account is saved and can be reused for future bill payments.

Verified bank accounts are stored as saved ACH payment methods using Stripe PaymentMethod objects of type us_bank_account. Customers can list their saved bank accounts by querying Stripe's PaymentMethods API, view key identifying metadata such as the bank name and last four digits, select a specific payment method when creating a bill payment, and delete accounts by detaching the PaymentMethod from the Stripe customer to prevent future use.

Because ACH payments have long processing times, after asking customers we designed the flow around asynchronous settlement. Bill payments initially enter a pending state and are treated as successful for balance calculations, allowing customers to continue operations without waiting for bank settlement. The payment state is later finalized as succeeded or failed once the bank outcome is known, with the ledger updated accordingly.

A scheduled cron job reconciles ACH payments and refunds by querying Stripe for the latest status of associated PaymentIntents. It polls pending ACH PaymentIntents to determine whether they ultimately succeeded or failed, expanding the intent to retrieve charge details when available. If a payment fails, the system triggers a bill payment refund and updates the ledger accordingly. The cron also monitors for failed bill payment refunds on Stripe's side.

Lastly, I extended the existing autopay system to support ACH as a primary payment method, enabling scheduled bill payments to draw from saved bank accounts. I also implemented a notification pipeline that emits events on ACH payment state transitions and routes them to email, SMS, and in-app channels. These notifications are delivered via SendGrid and Twilio and are triggered for key outcomes such as successful settlement and failed payments, ensuring customers receive timely, consistent updates throughout the asynchronous ACH lifecycle.

The flow:

<img src="/images/proj.png" alt="Rundoo flow" style="max-width: 100%; height: auto; margin: 20px 0;">
  `,
  // Internships
  "Faire - Software Engineering Intern": `
Faire is a late stage YC startup and a Forbes 2025 Top Startup Employer. They're an online wholesale marketplace that connects brands to retailers, with a mission
of "empowering entrepreneurs to chase their dreams". I worked on the Discovery team, which helps retailers find new brands and products quickly.

More about my work:

• Analyzed user behavior with SQL and Python (Pandas, Matplotlib), then enabled early rendering with TypeScript and Kotlin by prefetching APIs on user actions, cutting load times to under 1s for 77% of users (up from 50%)

• Frontend DRE for a product recommendation system that led to a 1.5% increase in order volume

• Migrated 30+ components from MobX/class-based architecture with Vanilla Extract to React hooks or RSCs with Tailwind CSS to support a server-driven UI

• Implemented impression context providers in TypeScript that track over 500k clicks and views daily across all product carousels.
`,
  
  "Johnson & Johnson - Data + Backend": `
    • Main developer for an app created with Python, SQL, and HTML/CSS, hosted on AWS, enabling agencies to
update internal Snowflake tables, saving over 1000 hours/year by eliminating the need for company staff to handle
these updates.

• Developed a Python framework to detect improper data ingestions across both Snowflake and Delta tables on
Azure, identifying 472 faulty ingestions from the summer

• Prepared over 3000 datasets from survey collections for ML training using Pandas.
  `,
  
  
  // Projects
  "AWS Cloud Club Founder": `
    Founded the first AWS Cloud Club in Canada! Hosted a 100+ studnet conference at the AWS office, featuring GenAI + Infrastructure labs, and industry panels. Led a Machine Learning API Camp for 50+ students on integrating Amazon Rekognition and Textract into a Vue3 app. Ran workshops on S3 hosting, SageMaker, and more.
  `,
  
  "CFR Poker Optimization": `
    Implemented the Counterfactual Regret Minimization (CFR) algorithm to compute near-optimal strategies in a simplified poker environment. Built a recursive solver that traverses the game tree, updates regret values over multiple iterations, and converges toward a Nash equilibrium (a state where no player can unilaterally improve their outcome by changing their strategy).
  `,
  
  "RayTracer": `
    Work in progress! Check back soon.
  `,
  
  "Compiler": `
    Built a full compiler for a custom language in Scala, converting source code into MIPS assembly. It includes a maximal munch tokenizer, parser, symbol table for type checking, IR generation, and MIPS code output with basic garbage collection.
  `,
  
  "Octoproject": `
    Built a Bluetooth-based anti-theft system using accelerometers to detect when personal items are touched. Sends real-time alerts via a React Native app using push notifications and WebSockets. Backend built in Go and Python, with firmware in C on Raspberry Pi. Secured with JWT, deployed via Docker and GitLab CI/CD
  `,
  
  "Linguini": `
    My friendgroup built Linguini, a daily linguistic puzzle game where players generate the longest possible words within random categories and compete on global and group leaderboards. The project includes secure account management, group creation and invitations, daily CRON-generated games, word validation with requests, and both global and local leaderboard views. We implemented the system with a Postgres database, the T3 stack (TypeScript, React, Next.js, tRPC, Tailwind), and dataset-driven category parsing to ensure accurate gameplay.
    
     https://github.com/BalajiLeninrajan/linguini
  `,
  
  "MCP Marketplace Integration": `
    Mijiji is a tool that enitrely automates the online selling pipeline. A user uploads a photo, and the system handles the posting through autonomous browser agents. It also negotiates with buyers and notifies the user when a deal is made. Built with Poke's API, FastMCP, browser-use, and Anthropic Sonnet 4.
    https://github.com/16BitNarwhal/Mijiji
  `,
  
  "Ranking Redwood City Cafes Until I Go Broke": `
    At my Airbnb you can only book the kitchen twice a week for 2 hours max (im dead serious). I've therefore decided to use this term to go to tons of cafes. There's also not much else to do in redwood.

    Note I'm ranking them kind of harshly. If it's over a 5 then it's probably worth a visit.

    <h3>The Baker Next Door → 6/10</h3>
    <ul>
      <li>Order: Grain salad with smoked salmon and iced latte</li>
      <li>Literally no thoughts. It was good I guess. It tasted healthy.</li>
    </ul>

    <h3>Philz Coffee → 3/10</h3>
    <ul>
      <li>Order: rose latte</li>
      <li>Reminded me of starbucks but with worse options</li>
      <li>Studying pros: Has outlets</li>
      <li>Accidentally went twice because I forgot I've been here and ordered the same thing</li>
    </ul>

    <h3>Cafe Stellato → 10/10</h3>
    <ul>
      <li>Icecream/sorbet bar</li>
      <li>Order: dubai chocolate on chocolate chip cookie dough icecream</li>
      <li>They also have a lot of fruit sorbet flavours ill try next time</li>
    </ul>

    <h3>Coffebar → 7/10</h3>
    <ul>
      <li>Great vanilla latte</li>
      <li>A peanut butter + banana toast should not cost $12</li>
      <li>Lots of people working with laptops</li>
    </ul>
     <h3>Sanaa's Cafe → 8/10</h3>
    <ul>
      <li>Really good baklava</li>
      <li>Open late</li>
    </ul>


     <h3>Bloomsgiving Cafe → 10/10</h3>
    <ul>
      <li>Plant store and cafe in one</li>
    </ul>

    <h3>Coupa Cafe → 9/10</h3>
    <ul>
      <li>Right next to my office so I go here like every day for breakfast</li>
      <li>Reminds me of williams</li>
    </ul>

    <h3>Franklin Street Cafe  → 6/10</h3>
    <ul>
      <li>Right next to the caltrain station so its fun to watch the trains go by</li>
      <li>High quality food, massive portions</li>
      <li>It feels like this cafe is targeted towards an older generation</li>
    </ul>


    <h3>Con Azucar Cafe → 100/10</h3>
    <ul>
      <li>Order: chiquito Iced duvalin latte (I have no clue what duvalin is but it was so good) and a torta de jamon sandwich</li>
      <li>Mexican cafe with STUNNING colorful decor everywhere. The atmosphere is really relaxed. The food was great too. It literally feels like you're on vacation. I will 100% come here again.</li>
      <li>Studying pros: Dim lighting and spanish music makes it easy to lock in. I was here for like 6 hours.</li>
      <li>I went like 3 more times after this (do not get the pepino con limon please)</li>
    </ul>
  `,
  
  "Ranking Broadway Musicals": `
    Note: There isn't a single one that I would say don't watch, these rankings are purely based on my opinions.

    <h3>Wicked - 8/10</h3>
    <ul>
      <li>A classic. Met all my expectations the singing was amazing!</li>
    </ul>

    <h3>Hadestown - 10+/10</h3>
    <ul>
      <li>I used to love greek mythology growing up</li>
      <li>Hadestown is a retelling of the orpheus and eurydice myth. You know how it will end but you still root for the characters anyways.</li>
      <li>some politics —> the underworld mirrors capitalism and Hades is forcing the workers to build "the wall"</li>
      <li>Catchy songs</li>
      <li>I watched it with the original cast and the actor who played Hades is recognized for singing some of the lowest notes ever performed in a Broadway show</li>
    </ul>

    <h3>Hell's Kitchen - 2.5/10</h3>
    <ul>
      <li>Apparently it's supposed to partially be about the life story of Alicia Keys. I didn't know this until someone told me after the show. The plot felt all over the place. It was about a girl growing up in a poor part of new york and her struggles with her relationship with her mom (who was divorced). The girl was also falling in love with a street drummer boy, and a lady who was dying who lived in her building was teaching her how to play the piano.</li>
      <li>They sang empire state of mind during it which was so cringe</li>
      <li>The one positive thing I have to say about it is the main actress was really good she reminded me of Zendaya</li>
    </ul>

    <h3>Moulin Rouge - 2/10</h3>
    <ul>
      <li>I completely forgot the plot already</li>
      <li>It was a jukebox musical so they used regular pop songs and tried to fit them into the musical. Like for example I remember them breaking out into singing chandelier by sia during an emotional scene.</li>
    </ul>

    <h3>Hamilton - 8/10</h3>
    <ul>
      <li>I was listening to the songs for many months afterwards</li>
    </ul>

    <h3>SIX - 7/10</h3>
    <ul>
      <li>It was about the 6 wives of King Henry the VIII. The songs were catchy and it was nice that they gave the wives a way to tell the story from their perspectives (instead of just being remembered as Henrys failed relationships)</li>
      <li>The idea that the wives are singing their stories and competing for who had it worse is definitely unique but it undermined the supposed female empowerment aspect of the musical</li>
    </ul>

    <h3>Chicago - 4/10</h3>
    <ul>
      <li>The cell block tango was great</li>
      <li>The stage set barely changed throughout the play it was pretty boring honestly</li>
    </ul>

    <h3>Operation Mincemeat - 3/10</h3>
    <ul>
      <li>The concept was cool it was about an operation during WW2 where the British used a dead body with fake invasion plans to trick the Germans</li>
      <li>I personally didn't find all the british humor funny and the main character annoyed tf out of me</li>
    </ul>

    <h3>Great Gatsby - 10/10</h3>
    <ul>
      <li>Tied for personal favorite with hadestown</li>
      <li>Haven't watched the movie or read the book beforehand so the plot was a surprise</li>
      <li>I felt touched by the idea that Gatsby was chasing a dream that was obviously impossible, and his belief in it was so strong that it made you believe in it too until it all came crashing down at the end. It makes you reflect on your own dreams of the future and how hope can be both a driving factor but also extremely blinding.</li>
    </ul>

    <h3>Ones I want to watch next:</h3>
    <ul>
      <li>Mamma mia —> had an abba summer phase a couple of years ago so I still know the songs pretty well</li>
      <li>Merrily We Roll Along —> I heard its about a friend group but the plot moves backwards in time. It starts with a huge argument the friends have, then goes back through their lives. At the end of the musical you see the friends meet and they're all so full of hope. It feels bittersweet because you know they will make many good memories but also how it will turn out. At the same time, knowing their long history makes you hopeful they will sort everything out and come back together in the future.</li>
      <li>Maybe Happy Endings —> Won a bunch of tonys</li>
      <li>Les Miserables → I love sad stories I don't think its on broadway rn though</li>
    </ul>
  `,
  
  "Life Milestones": `
    <h3>Planning Stacey's Surprise Bachelorette</h3>
    <p>Just a really core memory.</p>
    <p>To impress a New Yorker who has seen all of the West Coast we chose to do the lower middle of the US. Santa Fe has really cute architecture, group craft/sport activities, and places to go out.</p>

    <h3>Toronto Half Marathon</h3>
    <p>Honestly the choice to run this was really spontaneous and I don't think I trained enough for it (I had to search up mid race how many miles a half-marathon is). The crowd energy and signs (ex, "you're faster than the ttc") made the race a lot of fun though. I will definitely do a half marathon again!</p>

    <h3>AGG Team Canada</h3>
    <img src="/images/gymn.jpg" alt="Gymnastics" style="max-width: 100%; height: auto; margin-bottom: 20px;">
    
    <p>I've been doing gymnastics since I was 5 and I'm really grateful I got to spend the last few years leading up to uni (and a little into uni) travelling and competing with the best team + coach I could've asked for.</p>

    <h3>Maid of Honor Speech</h3>
    <img src="/images/bd.jpg" alt="Bridal party" style="max-width: 100%; height: auto; margin-bottom: 20px;">
    
    <p>I'm really honored to be giving this speech in front of all of you. Thank you for coming all this way to make Staceys and Jaspers day so special. Shoutout to my family for not being late for once, it really is a miracle. Lastly, shoutout to Stacey's mom, who's really got it going on.</p>

    <p>It feels so surreal to be standing here in Niagara-on-the-Lake on Stacey and Jasper's wedding day especially because it was right here, around eight years ago, that we met Jasper for the first time. I remember seeing Jasper and Stacey hold hands. It was really cute but I also remember being SO confused. When I was younger Stacey told me she wants to be the cool single aunt who travels the world. Who was this man who convinced her otherwise?</p>

    <p>Honestly though, Stacey has never been predictable and that's what makes her story so great. So before we get to this part with Jasper, let's rewind to where it all began.</p>

    <p>*Rewind*\n Growing up with Stacey. Stacey could make even the most boring things fun. Whether it was her running full speed as she slid me or Nika across the hallway in costco cardboard boxes, her creating makeshift indoor tents out of chairs and blankets or her going out into the backyard during thunderstorms to do cartwheels with us and then afterwards coming in soaked and covered in grass.</p>

    <p>We also learned some really cool skills from her. We learned how to whistle with blades of grass, , and how to catch frogs. No, really, one time we caught 111 frogs in one day. On a more serious note, she taught me how to make the most out of life, how to always have a positive energy, and how to be a good older sister for nika.</p>

    <p>When she headed off to university, it was the first time home felt a little incomplete. We went from placing seven forks at the dinner table to six, and that tiny difference felt bigger than we could have imagined. Our home became a place to gather, but never again a place where we all live together. We started by going to visit her every weekend. Then it was once a month. And when she moved to Seattle, we had to get used to catching up over our family whatsapp calls instead.</p>

    <p>I've come to realize though, that she was never really fully gone. This was visible through subtle things at first, like her paintings hanging on every wall of the house, all the hand-me-downs we wore, and her room being left exactly how she left it 10 years ago. Then we started noticing holidays like new years became so much more special when she came home. And it wasn't just the things she left behind, it was all the life choices I ended up taking because she chose them first and she was my rolemodel.</p>

    <p>In so many ways, Stacey has always been someone whose presence shapes everything around her. And tonight shows just how many people she and Jasper have touched along the way. All of you here have been such an important part of their lives, whether you grew up with them, helped them find each other, or stood by their side, you've helped create thousands of memories and you'll be part of so many more.</p>

    <p>Now to the couple, when I first visited you guys in New york, something that struck me was the figurines on your shelves. I could easily identify which ones were jaspers and which ones were staceys. Jaspers dragons were sleek and intimidating and staceys were somehow cute??? Yet the mix of them sitting side by side on a shelf looked like a full collection. It looked complete. You two complement each other perfectly. Stacey's love for the unknown and Jasper's love for thinking things through. How calm and collected Jasper is while playing overcooked yet how chaotic Stacey is running around and putting out fires.</p>

    <p>You also extend each other though. The way you both love adventures, games, exploring the world and that weird cooking show called delicious in the dungeon i will forever judge you for watching.</p>

    <p>Jasper, you are the most perfect person for Stacey and you both bring out the best in each other.</p>

    <p>Your future has so much in store for the two of you. On a smaller scale, dnd plot twists, discovering new brooklyn coffee/matcha shops, assembling new lego sets and maybe opening up a restaurant in santa fe stacey. On a large scale, love and accomplishing your dreams together.</p>

    <p>Jasper, you are now officially part of the family though it already feels like you have always been.</p>

    <p>Jasper, we hope you enjoy growing old with stacey as much as we enjoyed growing up with her.</p>
    <p>To the newlyweds!</p>

    <p>My sisters reaction to the speech ❤️:</p>

    <img src="/images/stacey.jpg" alt="Stacey" style="max-width: 100%; height: auto; margin-top: 20px;">

    <h3>WENT SKYDIVING IN HAWAII!!!</h3>
    <p>The view is gorgeous you can see the whole island (craters, white caps of waves, mountains, etc.)</p>
    <p>I did NOT believe this would make it out of the gc thanks Iman + Jonathan for being my most spontaneous friends.</p>
    <div style="display: flex; gap: 10px; margin-top: 20px; flex-wrap: wrap;">
      <img src="/images/before.jpg" alt="Before" style="max-width: 280px; height: auto; flex: 0 0 auto;">
      <img src="/images/plane.jpeg" alt="Plane" style="max-width: 280px; height: auto; flex: 0 0 auto;">
      <img src="/images/flight.jpeg" alt="Flight" style="max-width: 280px; height: auto; flex: 0 0 auto;">
    </div>


    <h3>Half Marathon #2 (Quarry Lakes Zombie Runner)</h3>
    <p>First half marathon where I didn't stop to walk! This one also didn't have any crowds so there wasn't any adrenaline and I'm really proud of this one.</p>
  `,
  
  "Short Thoughts": `
    <h3>My Grandparents</h3>
    
    <h4>Same stories</h4>
    <p>Whenever I visit my grandparents place I hear the same stories over and over again... the story of her pet parrot, the first time she saw me, how she met my grandpa, my mother moving abroad for uni, etc. Stories I know by heart. Every time she tells them she's just as excited to tell it as she was last time. Does she remember she told me these already? I never ask because I don't really want to know.</p>
    
    <p>I always wonder if I'll tell the same memories repeatedly when I'm older. If yes, which moments will be so meaningful to me that my eyes will light up thinking about them almost 60 years later as I retell them over and over again?</p>
    
    <h4>Time passing</h4>
    <p>When I was younger and my grandpa was in the garden, I would always open the curtain and wave to him from the window.</p>
    
    <p>Last week, my grandpa was in the garden. He doesn't live with us anymore, he was just visiting. I open the curtain. He looks up at the movement. I wave... as I always used to. He stands there looking blankly in my direction. He can't see me. He's losing his vision.</p>
    
    <p>I go outside to the garden. I yell "dedyshka" (grandpa!). "Nika?" He asks.</p>
    
    <p>This isn't a sad story. He recognized me as soon as I approached him. It's just a reminder that nothing stays the same forever, and I should appreciate the little moments.</p>
    
    <h3>People of the future/past</h3>
    <p>I've come to realize that sometimes people I'm close with now are people I briefly crossed paths with many months earlier, back when they weren't really part of my life. It makes me wonder how many people we meet without realizing how significant they might eventually become.</p>
    
    <p>It works the other way too. When I read Circe by Madeline Miller, I found it interesting that since she's immortal, countless lives touched hers but only for a moment. Our lives are like that in smaller ways. Sometimes someone is part of your everyday, and then without realizing it, you've already had your last interaction with them.</p>
  `,
  
  // Hackathons
  "Technova (WINNER)": `
    Flock $tocks is a stock recommendation app with live debates. After logging in, users are shown stock suggestions based on their preferences and income. A joystick lets them switch between 3D creatures with very different viewpoints, who debate whether to invest. At the end, users receive personalized portfolios and performance dashboards for their chosen stocks. Built with React, Python, Flask, Streamlit, ElevenLabs, OpenAI, Whisper, PropelAuth, and Spline.
    
  `,
  
  "HackMIT": `
    VR Tea with Iroh is a therapeutic VR experience where users sit down for tea with a realistic 3D Uncle Iroh. The avatar remembers past conversations, responds to emotions, and dynamically changes the scene and music based on user mood. Songs are generated on the spot using the Suno API. Built with Unity, C#, Python, Whisper, ElevenLabs, Vapi, Suno, and Convex.
  `,
  
  "SheHacks (WINNER)": `
    SqWiTS Game is a Squid Game-inspired study punishment app that uses computer vision and behavioral prediction to keep users off their phones. A Random Forest model predicts survival chances at the start.
    Users lose lives when they check their phone and face escalating punishments—like like having to gather people into their camera frame, generating AI roast songs or sending embarrassing emails. The app includes a talking guard avatar for “motivational” insults. Created with React, YOLOv5, Flask, Websockets, OpenAI, Databricks, and Procreate hand-drawn characters.
  `,
  
  "Hack the North": `
    SocialEye is a smart home surveillance system that connects to Discord. Using multithreading and a Raspberry Pi, it detects movement and sends footage and alerts to a Discord user in real-time. Built with Python, Flask, Google Cloud, Replit, and Discord bot integration.
  `,
  
  "Web3Apps (WINNER)": `
    Terra Taskers gamifies sustainability. Users complete weekly eco-tasks and post proof to a global feed. Verified tasks earn them FLOW crypto rewards via smart contracts. Built with Flask, Python, Circle API, HTML/CSS/JS, and deta.space.
  `,
  
  "HawkHacks": `
    HydroPal uses computer vision to track water intake and grows a virtual plant as users drink water. Meeting daily goals earns Metis tokens for customizing the app or gifting points to friends. Built with React, Flask, YOLO, MongoDB, Solidity (Sepolia testnet), and deployed with smart contracts.
  `,
  

  "Susquehanna Discovery": `
    Intro to quant trading, learned about SIGs culutre, and practiced probability techniques.
  `,
  
  "Citadel Boundless": `
    At the Philadelphia Museum of Art, I met Judit Polgár, the top female chess player in history. She shared how she prepared for tournaments, her strategy to beat Kasparov using his own techniques, and her advice for succeeding as a woman in a male-dominated field. We watched her beat four of us at once in a live match, then ended the evening networking with Citadel traders and engineers.
  `,
  
  "Jane Street WISE (2023), WiSE Reunion (2024), Insight - SWE Track (2025)": `
    Travelled to NYC with some of the coolest students I've ever met. We learned OCAML programming and probabilities, played strategic thinking games, learned about
    market making + liquidity provision, and more about the firm in general.

    We also went to a WiSE Reunion program one year later at the NYC office as well.
  `,
  
  "Grace Hopper": `
    Largest gathering of women in tech.
  `,
  
  "Harvard WeCode": `
    Networking conference that I received the WiCS Innovation fund to attend. I met Tracy from AWS here, who inspired me to start the AWS Club at Waterloo.
  `,
  
  "OpenAI Leadership Exchange": `
    Met cool people
  `,
  
  "More Coming Soon...": `
    Feel free to reach out if you'd like to collaborate on something interesting!
  `,
  
  "Coming Soon...": `
    <iframe
      src="https://open.spotify.com/embed/track/4W6yulge3h7FSy0zGFrNKs?utm_source=generator&theme=0"
      width="100%"
      height="152"
      frameborder="0"
      style="border-radius: 12px; border: 0;"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
      title="Orbiter - Noah Kahan on Spotify">
    </iframe>
  `,

  "Mural": `
    Spent over 40 hours painting a mural at my highschool. The mural has a hidden message/puzzle —> every tile hides one word. To this day nobody has solved the puzzle :(
  `,

  "Notion - Infra Backend Intern": `
Detailed description coming soon!

<strong>Summary:</strong>

• Built 'Associations', a cross-shard distributed data model in TypeScript and PostgreSQL for arbitrary bidirectional relationships, with paginated lookups, reactive list caching, overflow queue processing, and CDC/Kafka-based reconciliation

• Improved synced-block data consistency by migrating a legacy two-pointer architecture to Associations through automated data backfills, dual writes, dark reads, feature-gated rollout, and latency monitoring

• Built an automated Knip ratchet workflow with cron-based expiry for unused TypeScript exports, reducing the codebase without blocking developer workflows
  `,

  "Hack the North - Sponsorships Team": `
<strong>Main quests:</strong> Sponsorships (record $X,XXX,XXX raise), VC involvement + panel

<strong>Side quests:</strong> ceremonies MC + script, decor squad
  `
};

export default projectDescriptions; 